import { inject, Pipe, PipeTransform, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    name: 'translateLabel',
    pure: false,
    standalone: true,
})
export class TranslateLabelPipe implements PipeTransform {
    public readonly translateService = inject(TranslateService);
    
    transform(label: string): string {
        if (!label) return null;
        const words = label?.split(' ');

        if (!words) return null;
        const translatedWords: string[] = [];
      
        words?.forEach((word, index) => {
            if (!word) return null;

            this.translateService.get(word).subscribe((res) => {
            translatedWords[index] = res;
          
            if (translatedWords?.length === words?.length && !translatedWords?.includes(undefined)) {
              return translatedWords.join(' ');
            }
    
            return translatedWords[index];
          });
        });
        
        return Object.values(translatedWords).join(' ');
    }
}